import React from "react";
import {FormattedDate, FormattedTime} from "react-intl";

export const FormattedDateTime = ({value}) => (
    <>
        <FormattedDate month='2-digit' day='2-digit' year='numeric' value={value}/> <FormattedTime value={value}/>
    </>
)